import { render, staticRenderFns } from "./imgPdetailList.vue?vue&type=template&id=01c27d8e&scoped=true&"
import script from "./imgPdetailList.vue?vue&type=script&lang=js&"
export * from "./imgPdetailList.vue?vue&type=script&lang=js&"
import style0 from "./imgPdetailList.vue?vue&type=style&index=0&id=01c27d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c27d8e",
  null
  
)

export default component.exports